export const Wordmark = ({ light = false, className = "" }) => (
  <div className={`leading-none ${className}`} data-testid="brand-wordmark">
    <div className={`font-serif text-[1.65rem] font-semibold tracking-tight ${light ? "text-[#FDFBF7]" : "text-[#2C1810]"}`}>
      Ink <span className="italic text-[#C5A059]">Genius</span>
    </div>
    <div className={`mt-1 text-[0.7rem] font-medium tracking-[0.14em] ${light ? "text-[#E8BDB5]" : "text-[#A88B7D]"}`} data-testid="brand-byline">
      by <span className="font-semibold">MooreBeautyLove</span>
    </div>
  </div>
);

export const Disclosure = ({ compact = false, testId = "professional-disclosure" }) => (
  <p
    data-testid={testId}
    className={`text-[#6E5549] ${compact ? "text-[11px] leading-relaxed" : "text-xs leading-relaxed"}`}
  >
    <span className="font-semibold text-[#3D2317]">Professional-use disclosure.</span> Ink Genius is educational
    decision support for trained PMU professionals. It does not provide clinical or medical clearance, does not
    guarantee healed results, and does not replace the artist's own hands-on assessment. The artist makes the final
    decision.
  </p>
);
